import * as React from 'react';
import { onlyPublic } from '../../utilities/only-public';
import { __ } from 'react-i18n';

import { ButtonText, Line, OrLabel, OrText, SocialsLogo } from './Login';

import { FormInputComponent } from 'eshop-defaults';
import { Button } from 'eshop-defaults';
import { ButtonPrimary } from 'eshop-defaults';

interface Props {
  regData: {
    email: string;
    pass: string;
    passAgain: string;
  };
  handleRegister: (e: any) => {};
  onRegDataChange: (data: object) => void;
  handleFacebook: () => {};
  handleGoogle: () => {};
}

class Register extends React.Component<Props> {
  public render() {
    const { email, pass, passAgain } = this.props.regData;

    return (
      <React.Fragment>
        <form onSubmit={this.props.handleRegister}>
          <FormInputComponent
            label={__('Email')}
            type="email"
            placeholder={__('bart@bart.sk')}
            required={true}
            onChange={this.onChangeEmailInput}
            value={email}
            autoComplete="email"
          />

          <FormInputComponent
            label={__('Heslo')}
            type="password"
            placeholder="***********"
            required={true}
            onChange={this.onChangePassInput}
            value={pass}
            autoComplete="new-password"
          />

          <FormInputComponent
            label={__('Heslo znovu')}
            type="password"
            placeholder="***********"
            required={true}
            onChange={this.onChangePassAgainInput}
            value={passAgain}
            autoComplete="new-password"
          />

          <ButtonPrimary roundOnMobile={true} style={{ marginTop: 25 }}>
            {__('Registrovať sa')}
          </ButtonPrimary>
        </form>

        <OrLabel>
          <Line />
          <OrText> {__('alebo')} </OrText>
          <Line />
        </OrLabel>

        <Button
          style={{ margin: '10px 0' }}
          roundOnMobile={true}
          color="#3B5998"
          click={this.props.handleFacebook}
        >
          <SocialsLogo src={'/images/facebook-box.svg'} />
          <ButtonText> {__('Registrácia cez Facebook')} </ButtonText>
        </Button>

        <Button
          style={{ margin: '10px 0' }}
          roundOnMobile={true}
          height="40px"
          color="#DD4B39"
          click={this.props.handleGoogle}
        >
          <SocialsLogo src={'/images/google.svg'} />
          <ButtonText> {__('Registrácia cez Google')} </ButtonText>
        </Button>
      </React.Fragment>
    );
  }

  private onChangeEmailInput = e => {
    this.props.onRegDataChange({ email: e.target.value });
  };

  private onChangePassInput = e => {
    this.props.onRegDataChange({ pass: e.target.value });
  };

  private onChangePassAgainInput = e => {
    this.props.onRegDataChange({ passAgain: e.target.value });
  };
}

export default onlyPublic(Register);
